import React from 'react'
import { Redirect } from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import ProjectTypeForm from './ProjectTypeForm'
import ProjectTypeCard from './ProjectTypeCard'

import Resource from '../../stores/resource'
const ProjectTypeStore = Resource('project-types')

class NewProjectType extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      projectType: this.props.attributes || {},
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = attributes => {
    ProjectTypeStore.create(attributes)
      .then(result => {
        this.setState(
          {
            saved: true,
            error: '',
            savedProjectType: result.data.data,
            snackbarMessage: `Project type "${attributes.name}" created!`
          },
          () => {
            if (this.props.savedCallback) {
              this.props.savedCallback(this.state.savedProjectType)
            }
          }
        )
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  _closeSuccessDialog = () => this.setState({ redirect: `/project-types` })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    const {
      redirect,
      saved,
      snackbarMessage,
      error,
      projectType,
      savedProjectType
    } = this.state

    const name = projectType.attributes ? projectType.attributes.name : ''

    const {
      formTitle,
      forceChanged,
      cancelCallback,
      showSuccessDialog
    } = this.props

    if (redirect) return <Redirect push to={redirect} />

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog} />
    ]

    return (
      <section>
        <ProjectTypeForm
          formTitle={formTitle}
          name={name}
          forceChanged={forceChanged}
          submitCallback={this._save}
          cancelCallback={cancelCallback}
        />
        <br />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create project type"
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved &&
          showSuccessDialog && (
            <Dialog
              actions={successDialogActions}
              modal={false}
              onRequestClose={this._closeSuccessDialog}
              open={Boolean(saved)}
              title="Project type created"
            >
              <p>
                A new project type has been created with the information below.<br />
                If you see any incorrect information, press the{' '}
                <strong>Edit</strong> button.
              </p>
              <ProjectTypeCard
                projectType={savedProjectType}
                editCallback={() =>
                  this._redirectTo(`/project-types/${savedProjectType.id}/edit`)
                }
              />
            </Dialog>
          )}
      </section>
    )
  }
}

export default NewProjectType



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/NewProjectType.jsx